<script setup lang="ts">
  import type { PlanAccordeonItem } from '../../FlowSelectPlanWidget.types'
  import SinglePlanAccordeonItem from '../SinglePlanAccordeonItem/SinglePlanAccordeonItem.vue'

  interface Props {
    data: PlanAccordeonItem[]
  }

  interface Emits {
    (e: 'click-learn-more'): void
    (e: 'toggle', isOpen: boolean, coverage: PlanAccordeonItem): void
  }

  defineProps<Props>()
  const emit = defineEmits<Emits>()
</script>

<template>
  <div class="single-plan-accordion">
    <SinglePlanAccordeonItem
      v-for="item in data"
      :key="item.title"
      :item="item"
      @click-learn-more="emit('click-learn-more')"
      @toggle="emit('toggle', $event, item)"
    />
  </div>
</template>
